import { ReactComponent as FlagIcon } from "./svg/pl-flag.svg";
import "../flag-icon.scss";

export const PLFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
